// AI学習用データ（media_ai_training_data）
// AI が生成時に参照するサイト固有の参考データ。サイトごとに1件。
export interface MediaAiTrainingData {
  site_id: number
  // 記事HTML（コンテンツHTMLの型）。未登録は空文字
  article_html: string
  // 共通ルール＞制約・禁止事項。未登録は空文字
  restrictions: string
  updated_at: string | null
}

// 記事HTMLの入力上限（backend/schemas/media_ai_training_data.py の ARTICLE_HTML_MAX_LENGTH と対応）
export const ARTICLE_HTML_MAX_LENGTH = 100000

// 制約・禁止事項の入力上限（同 RESTRICTIONS_MAX_LENGTH と対応）
export const RESTRICTIONS_MAX_LENGTH = 10000
